<template>
  <div id="communication-information">
    <v-card id="v-card" v-if="StartupLoadingFlag">
      <v-container>
        <v-row wrap>
          <v-col cols="12" xl="6" md="6" sm="6" v-for="n in 4" :key="n">
            <br />
            <br />
            <v-skeleton-loader
              v-bind="attrs"
              type="paragraph"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card
      elevation="4"
      outlined
      shaped
      v-if="!StartupLoadingFlag"
      id="v-card"
    >
      <br />

      <v-row wrap>
        <v-col cols="12">
          <h3 class="text-dark lg-ml-3 ml-3">
            <v-icon id="app-bar-icon">fas fa-id-card</v-icon>&nbsp;&nbsp;
            <b id="heading">Aadhar Details</b>
          </h3>
        </v-col>
      </v-row>

      <v-card-text style="padding-left: 1%; padding-right: 0%" id="card-text">
        <v-container class="py-0">
          <v-row wrap>
            <v-col cols="10" lg="10">
              <h6>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-icon v-bind="attrs" v-on="on" :color="MobileNoIconColor">
                      {{ MobileNoIcon }}
                    </v-icon>
                  </template>
                  <span>{{ MobileNoVerifiedTxt }}</span> -->
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      :color="member.AadharNoIconColor"
                    >
                      {{ member.AadharNoIcon }}
                    </v-icon>
                  </template>
                  <span>{{ member.AadharNoVerifiedTxt }}</span>
                </v-tooltip>
                <!-- <v-icon :color="MobileNoIconColor">{{ MobileNoIcon }}</v-icon> -->
                &nbsp; <span class="text-dark-50">Aadhar Number</span> :
                {{ member.AadharNo }}
              </h6>
              <v-row align="center" no-gutters>
                <v-col cols="auto" class="mr-2">
                  <h6><span class="text-dark-50">Verify Status:</span></h6>
                </v-col>
                <v-col cols="auto">
                  <v-chip :color="member.AadharNoIconColor" dark small>
                    {{ member.AadharNoVerifiedTxt }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2" lg="2" v-if="member.AadharNoVerified == 0">
              <!-- <v-icon id="edit-icon" @click.prevent="addAadhaarNoPrompt = true">
                fas fa-edit
              </v-icon> -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    id="edit-icon"
                    @click.prevent="addAadhaarNoPrompt = true"
                    v-bind="attrs"
                    v-on="on"
                  >
                    fas fa-edit
                  </v-icon>
                </template>
                <span> Edit </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="addAadhaarNoPrompt"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
      @keydown.esc="addAadhaarNoPrompt = false"
    >
      <v-card>
        <aadhar-number-change
          pageDescription="Change Aadhar number"
          :addRecordPrompt="addAadhaarNoPrompt"
          @hideAddRecordPrompt="hideAadhaarNoPrompt($event)"
          v-if="addAadhaarNoPrompt"
        ></aadhar-number-change>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addEmailIdPrompt" persistent width="auto">
      <member-email-id-change
        pageDescription="Change Email Id"
        :addRecordPrompt="addEmailIdPrompt"
        @hideAddRecordPrompt="hideEmailIdPrompt"
        v-if="addEmailIdPrompt"
      ></member-email-id-change>
    </v-dialog>

    <v-dialog v-model="addRecordPrompt" persistent max-width="80%">
      <member-communication-details
        v-if="UserFlag && addRecordPrompt"
        :MemberId="MemberId"
        @hideAddRecordPrompt="hideAddRecordPrompt"
      ></member-communication-details>
    </v-dialog>
  </div>
</template>

<script>
import companyConfig from "@/company_config.json";
import common from "@/view/Common.vue";
import Swal from "sweetalert2";

import MemberMobileNoChange from "@/view/pages/profile/my-profile/MemberMobileNoChange";
import MemberEmailIdChange from "@/view/pages/profile/my-profile/MemberEmailIdChange";
import MemberCommunicationDetails from "@/view/pages/profile/profile-cards-1/MemberCommunicationDetails";
import AadharNumberChange from "@/view/pages/profile/my-profile/AadharNumberChange";

import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  mixins: [common],
  components: {
    MemberMobileNoChange,
    MemberEmailIdChange,
    MemberCommunicationDetails,
    AadharNumberChange,
  },

  data() {
    return {
      digilockerUrl: "",
      popupFlag: false,

      StartupLoadingFlag: false,
      MemberId: 0,
      member: {},
      UserFlag: false,
      addRecordPrompt: false,

      addAadhaarNoPrompt: false,
      addEmailIdPrompt: false,

      WhatsappNo: "",

      MobileNo: "",
      MobileNoVerified: "",
      MobileNoVerifiedTxt: "",
      MobileNoIcon: "",
      MobileNoIconColor: "",

      EmailId: "",
      EmailIdVerified: "",
      EmailIdVerifiedTxt: "",
      EmailIdIcon: "",
      EmailIdIconColor: "",

      AadhaarNo: "",
      AadhaarNoVerified: "",
      AadhaarNoVerifiedTxt: "",
      AadhaarNoIcon: "",
      AadhaarNoIconColor: "",
    };
  },
  computed: {},
  watch: {
    member: function () {
      console.log("watch member contact");
      var member = this.member;
      console.log("member=" + JSON.stringify(member));
      this.MemberId = member.hasOwnProperty("MemberId") ? member.MemberId : "";
      this.WhatsappNo = member.hasOwnProperty("WhatsappNo")
        ? member.WhatsappNo
        : "";
      this.MobileNo = member.hasOwnProperty("MobileNo") ? member.MobileNo : "";
      this.MobileNoVerified = member.hasOwnProperty("MobileNoVerified")
        ? member.MobileNoVerified
        : "";
      this.MobileNoVerifiedTxt = member.hasOwnProperty("MobileNoVerified")
        ? member.MobileNoVerifiedTxt
        : "";

      this.MobileNoIcon = member.hasOwnProperty("MobileNoIcon")
        ? member.MobileNoIcon
        : "";

      this.MobileNoIconColor = member.hasOwnProperty("MobileNoIconColor")
        ? member.MobileNoIconColor
        : "";

      this.EmailId = member.hasOwnProperty("EmailId") ? member.EmailId : "";
      this.EmailIdVerified = member.hasOwnProperty("EmailIdVerified")
        ? member.EmailIdVerified
        : "";
      this.EmailIdVerifiedTxt = member.hasOwnProperty("EmailIdVerified")
        ? member.EmailIdVerifiedTxt
        : "";
      this.EmailIdIcon = member.hasOwnProperty("EmailIdIcon")
        ? member.EmailIdIcon
        : "";
      this.EmailIdIconColor = member.hasOwnProperty("EmailIdIconColor")
        ? member.EmailIdIconColor
        : "";

      this.AadhaarNo = member.hasOwnProperty("AadhaarNo")
        ? member.AadhaarNo
        : "";
      this.AadharNoVerified = member.hasOwnProperty("AadharNoVerified")
        ? member.AadharNoVerified
        : "";
      this.AadharNoVerifiedTxt = member.hasOwnProperty("AadharNoVerifiedTxt")
        ? member.AadharNoVerifiedTxt
        : "";

      this.AadharNoIcon = member.hasOwnProperty("AadharNoIcon")
        ? member.AadharNoIcon
        : "";

      this.AadharNoIconColor = member.hasOwnProperty("AadharNoIconColor")
        ? member.AadharNoIconColor
        : "";
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords is called");

      // var validate1 = this.$refs.form2.validate();
      var validate1 = true;
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SearchFlag = true;
        this.tableData1 = [];
        this.selected = [];
        this.selectedData = {};
        this.StartupLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members-details";
        var upload = {
          UserInterface: 1,
          MemberId: this.MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SearchFlag = false;
            thisIns.StartupLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            console.log("flag=" + flag + ", output=" + output);

            records = response.data.records;
            console.log({ records });

            // thisIns.tableOptions1 = records.TableOptions;

            if (flag == 1) {
              // thisIns.toast("success", output);
              thisIns.member = records;
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message, false);
      }
    },

    hideAadhaarNoPrompt(flag) {
      console.log("hideAadhaarNoPrompt called");
      this.addAadhaarNoPrompt = false;
      console.log({ flag });
      if (flag) {
        this.getTableRecords();
      }
    },
    hideEmailIdPrompt(flag) {
      console.log("hideEmailIdPrompt called");
      this.addEmailIdPrompt = false;
      console.log({ flag });
      if (flag) {
        this.getTableRecords();
      }
    },
    openRecordPrompt() {
      console.log("openRecordPrompt called");
      this.addRecordPrompt = true;
    },
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log(flag);
      if (flag) {
        this.getTableRecords();
      }
    },
  },
  mounted() {},
  beforeMount() {
    console.log("beforeMount called");
    console.log(this.$route.query.id);
    // this.MemberId = this.$route.query.id;
    var MemberId = this.$session.get("MemberId");
    MemberId = MemberId == (null || undefined) ? 0 : MemberId;
    console.log("my-profile beforeMount called");

    var token = this.$session.get("token");
    token = token == (null || undefined) ? 0 : token;

    if (token == 0) {
      this.$router.push("/login");
    } else {
      this.UserFlag = true;
      this.MemberId = MemberId;
      this.refreshPageData();
    }
  },
};
</script>